<script lang='ts'>
import Schedule from '../Schedule.svelte';
import { schedule } from '../../store';

export let sectionTitle;
export let title;
export let subtitle;
export let header;
export let showDaysOfWeek;
</script>

<Schedule sessions={$schedule} {title} {subtitle} {sectionTitle} {header} {showDaysOfWeek} />